















import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import InteractiveDataResults from './InteractiveDataResults.vue';

export default Vue.extend({
  components: {
    InteractiveDataResults,
  },
  props: {
    interactiveData: {
      type: Object,
      required: true,
    },
    questionId: {
      type: Number,
      required: true,
    },
    questionAnswer: {
      type: Number,
      required: true,
    },
    stats: {
      type: Array as Vue.PropType<Object>,
      default: null,
    },
    statsLoading: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    ...mapActions({
      pushReply: 'PUSH_REPLY',
      pullQuestionSolutions: 'PULL_QUESTION_SOLUTIONS',
    }),
  },
});
